import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { AddPatientRoutingModule } from './add-patient.routing';
import { AddPatientComponent } from './add-patient.component';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
    declarations: [
        AddPatientComponent
    ],
    imports: [AddPatientRoutingModule, SharedModule, ReactiveFormsModule, FormsModule, CommonModule],
    providers: [],
    bootstrap: []
})
export class AddPatientModule {
}




// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/add-patient/add-patient.module.ts